import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-bs-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));



	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));






})();

(function (Drupal) {
	'use strict';

	Drupal.behaviors.tailSelect = {
		attach: function (context) {
			// Use a string selector to target all elements in the current context
			const selectElements = once('tailSelectInit', 'select.tail-select-init', context);

			// Initialize tail.select for all selected elements
			if (selectElements.length > 0) {
				tail.select('select.tail-select-init', {
					animate: true,
					multiShowCount: true,
					multiSelectAll: false,
					locale: "da",
					strings: {
						all: "Alle",
						none: "Ingen",
						placeholder: "Vælg en mulighed...",
						search: "Skriv for at søge...",
					}
				});
			}
		}
	};

})(Drupal);










